
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { Company } from '../TitleList';
import { errorStyles } from '../../Utils/table';
import TitleBar from '../TitleBar';
import { useDispatch } from 'react-redux';
import { createFirmEntry, fetchCompanyData } from '../../Store/PHPSlice/Firm';

const FirmEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        firmNm: '',
        adrs: '',
        ph: '',
        emailId: '',
        pan: '',
        gst: '',
        website: '',
        bank: '',
        accNo: '',
        brnchNm: '',
        ifsc: '',
        userId: userdata?.ID,
        image: '',
        invNo: ''
    });
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchCompanyData());
    }, [dispatch]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle numerical inputs for contactNo and accNo
        if (name === 'ph' || name === 'accNo') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'ph' && value.length > 10) {
            return;
        }

        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
    };
    const handleImageChange = (e) => {
        setFormData({
            ...formData,
            image: e.target.files[0]
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.firmNm) newErrors.firmNm = 'Firm Name is required';
        if (!formData.ph) newErrors.ph = 'Contact No is required';
        // if (!formData.gst) newErrors.gst = 'GST is required';
        // if (!formData.pan) newErrors.pan = 'Pan is required';
        if (!formData.ph) {
            newErrors.ph = 'Contact is required';
        } else if (!/^\d{10}$/.test(formData.ph)) {
            newErrors.ph = 'Contact must be a 10-digit number';
        }

        // if (!formData.adrs) newErrors.adrs = 'Address is required';
        if (formData.emailId && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.emailId)) {
            newErrors.emailId = 'Invalid email address';
        }
        return newErrors;
    };


    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('firmNm', formData.firmNm);
        formDataToSend.append('adrs', formData.adrs);
        formDataToSend.append('ph', formData.ph);
        formDataToSend.append('emailId', formData.emailId);
        formDataToSend.append('pan', formData.pan);
        formDataToSend.append('gst', formData.gst);
        formDataToSend.append('website', formData.website);
        formDataToSend.append('bank', formData.bank);
        formDataToSend.append('accNo', formData.accNo);
        formDataToSend.append('brnchNm', formData.brnchNm);
        formDataToSend.append('ifsc', formData.ifsc);
        formDataToSend.append('userId', formData.userId);

        if (formData.image instanceof File) {
            formDataToSend.append('image', formData.image);
        }

        dispatch(createFirmEntry(formDataToSend))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Firm Added");
                alert("Firm Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };



    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement


    return (
        <>
            <TitleBar data={Company} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Firm Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>
                                {[
                                    { label: 'Firm Name', name: 'firmNm', required: true },
                                    { label: 'Email', name: 'emailId' },
                                    { label: 'Address', name: 'adrs', required: true },
                                    { label: 'Contact', name: 'ph', required: true },
                                    { label: 'Pan No', name: 'pan' },
                                    { label: 'GST No', name: 'gst' },
                                    { label: 'Bank Name', name: 'bank' },
                                    { label: 'Account No', name: 'accNo' },
                                    { label: 'Branch Name', name: 'brnchNm' },
                                    { label: 'IFSC Code', name: 'ifsc' },
                                    { label: 'WebSite', name: 'website' },
                                    { label: 'Firm Header Image', name: 'image', type: 'file' },

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>
                                                    {field.type === 'file' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            inputProps={{ style: styled.inputImg }}
                                                            sx={inputImages}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default FirmEntry;
